import { render, staticRenderFns } from "./Lot.vue?vue&type=template&id=c0889414&scoped=true"
import script from "./Lot.vue?vue&type=script&lang=js"
export * from "./Lot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0889414",
  null
  
)

export default component.exports